export enum FailureReasons {
  PRODUCT_API_FAILURE = 'PRODUCT_API_FAILURE',
  SMART_LINK_RESOLVE_FAILURE = 'SMART_LINK_RESOLVE_FAILURE',
  TEST_TIMEOUT = 'TEST_TIMEOUT',
}
